import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { AppDispatch } from "../../redux/store";
import { userLogin } from "../../redux/reducers/user";
import { getIP } from "../../utils/functions";
import { showErrorToast } from "src/utils/toast";

const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [user_name, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [touched, setTouched] = useState({ username: false, password: false });

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTouched({ username: true, password: true });
    if (!user_name || !password) return;

    const ip_address = await getIP();
    const data = {
      user_name,
      password,
      ip_address,
    };
    dispatch(userLogin(data))
      .unwrap()
      .then((res) => {
        if (res && res.data) {
          if (res.data.is_two_factor_authentication) {
            navigate("/2fa-auth/google");
          } else if (res.data.is_telegram_auth) {
            navigate("/2fa-auth/telegram");
          } else if (!res.data.is_password_changed) {
            navigate("/reset-password");
          }
        }
      })
      .catch((error) => showErrorToast(error as string));
  };

  return (
    <form autoComplete="off" onSubmit={handleLogin} className="form-horizontal">
      <div className="form-group">
        <div>
          <input
            id="input-1"
            name="username"
            type="text"
            placeholder="Username"
            className="form-control"
            value={user_name}
            onChange={handleUsernameChange}
            onBlur={() => setTouched((prev) => ({ ...prev, username: true }))}
          />
          {touched.username && !user_name && <span className="error">The username field is required</span>}
        </div>
      </div>

      <div className="form-group">
        <div>
          <input
            id="input-2"
            name="password"
            type="password"
            placeholder="Password"
            className="form-control"
            value={password}
            onChange={handlePasswordChange}
            onBlur={() => setTouched((prev) => ({ ...prev, password: true }))}
          />
          {touched.password && !password && <span className="error">The password field is required</span>}
        </div>
      </div>

      <div className="form-group text-center">
        <button type="submit" className="btn btn-submit btn-login btn-secondary">
          Login <i className="fas fa-sign-in-alt" />
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
